import axios from 'axios';
import { tokenStorage } from './tokenStorage';

export const API = '/api';

// One-shot migration: if an older build left the token in localStorage, move it to sessionStorage.
tokenStorage.migrateLegacy();

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = tokenStorage.get();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      tokenStorage.clear();
      localStorage.removeItem('ev_user');
      if (!window.location.pathname.startsWith('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;
